import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'api';

/**
 * Hook to export billing history as CSV
 * Returns CSV data as a string
 */
export const useExportBillingHistory = (enabled: boolean = false, ids?: string[]) => {
  return useQuery({
    queryKey: ['exportBillingHistory', ids],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      if (ids?.length) searchParams.append('ids', ids.join(','));

      const queryString = searchParams.toString();
      const url = `/billing/dashboard/billing-history/export/${queryString ? `?${queryString}` : ''}`;

      const response = await apiClient.get<string>(url);
      return response.data;
    },
    enabled,
    staleTime: 0, // Always fetch fresh data when enabled
  });
};
